import { Dialog, Text } from '@/ui'
import { GreenCheckRow, PayrollIntroCard } from './WelcomeToPayroll'
import { useReselector } from '@/utils/sharedHooks'
import { TextColors, TypographyStyles } from '@/styles'
import { selectUserHasPermission } from '@/reducers/auth/permission.selectors'
import { ProductFeatureId } from '@/actions/permissionActions'

export const LearnMorePayrollModal = ({
  open,
  onClose,
}: {
  open: boolean
  onClose: () => void
}) => {
  const hasFreePayrollWithSubscription = useReselector(
    selectUserHasPermission,
    ProductFeatureId.payrollIncludedForFreeForSelf
  )

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <Dialog.Content className="max-w-4xl p-6">
        <Dialog.Title>
          <Text variant={TypographyStyles.DISPLAY_SM}>
            Why setup payroll with Heard?
          </Text>
        </Dialog.Title>

        <div className="flex flex-col lg:flex-row gap-8 mt-4">
          <div className="w-full lg:w-1/2 flex-shrink-0">
            <PayrollIntroCard />
            <div className="mt-4">
              {!hasFreePayrollWithSubscription && (
                <Text
                  variant={TypographyStyles.BODY_MD}
                  color={TextColors.MUTED}
                >
                  If you migrate your Gusto payroll, you’ll only be charged by
                  Heard going forward.
                </Text>
              )}
            </div>
          </div>

          <div className="flex-1 flex flex-col gap-4">
            <Text variant={TypographyStyles.H3}>
              We provide what you need to stay compliant:
            </Text>

            <GreenCheckRow content="Automatic Payroll on a set schedule" />
            <GreenCheckRow content="Direct deposit of funds" />
            <GreenCheckRow content="Calculation and withholding of state and federal payroll taxes" />
            <GreenCheckRow content="Payroll documents automatically imported into Heard" />
            <GreenCheckRow content="Payroll history" />

            <Text variant={TypographyStyles.BODY_MD}>
              If you have other employees, you can also:
            </Text>

            <GreenCheckRow content="Pay contractors and hourly employees" />
            <GreenCheckRow content="Provide workers’ compensation" />
            <GreenCheckRow content="Compensate employees the way they need (e.g. overtime, bonuses, reimbursements)" />

            <Text variant={TypographyStyles.BODY_XS}>
              Not currently supported:
              <ul className="list-disc pl-6 mt-2">
                <li>Gusto Premium or Contractor Only plans</li>
                <li>Gusto-sponsored or employee benefits</li>
                <li>Time tracking</li>
                <li>100% commission-based payments</li>
                <li>Multiple pay rates for a teammate</li>
              </ul>
            </Text>
          </div>
        </div>
      </Dialog.Content>
    </Dialog>
  )
}
